import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const NAVY = '#0d2137';
const GREEN = '#1a6b3c';
const RED = '#c41e3a';
const SIDEBAR_W = 230;

const allNavItems = [
  { label: 'Dashboard',        path: '/dashboard',         icon: '📊', color: '#3b82f6', roles: ['admin', 'booking'] },
  { label: 'New Registration', path: '/register',           icon: '➕', color: GREEN,     roles: ['admin', 'booking'] },
  { label: 'Daily List',       path: '/daily-list',         icon: '📋', color: '#0ea5e9', roles: ['admin', 'booking'] },
  { label: 'Patient History',  path: '/patient-history',    icon: '🕐', color: '#8b5cf6', roles: ['admin', 'booking'] },
  { label: 'Appointments',     path: '/appointments',       icon: '📅', color: '#f59e0b', roles: ['admin', 'booking'] },
  { label: 'Doctor-wise List', path: '/doctor-list',        icon: '🩺', color: '#06b6d4', roles: ['admin'] },
  { label: 'Doctor Management',path: '/doctor-management',  icon: '👨‍⚕️', color: RED,      roles: ['admin'] },
  { label: 'Reports',          path: '/reports',            icon: '📊', color: '#059669', roles: ['admin', 'booking'] },
];

export default function Layout({ children, onLogout }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const location = useLocation();

  const userRole = localStorage.getItem('dha_role') || 'booking';
  const navItems = allNavItems.filter(item => item.roles.includes(userRole));
  const userName = localStorage.getItem('dha_name') || 'User';

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  const w = collapsed ? 64 : SIDEBAR_W;

  const sidebarContent = (mobile = false) => (
    <div style={{
      width: mobile ? SIDEBAR_W : w,
      minWidth: mobile ? SIDEBAR_W : w,
      background: NAVY,
      display: 'flex', flexDirection: 'column',
      height: '100%',
      overflow: 'hidden',
    }}>
      <div style={{ padding: (!mobile && collapsed) ? '18px 0' : '18px 16px 0 16px', borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
          <img src="/logo2.png" alt="DHA" style={{ height: 44, minWidth: 44, objectFit: 'contain', flexShrink: 0 }}
            onError={e => e.target.style.display = 'none'} />
          {(mobile || !collapsed) && (
            <div>
              <div style={{ fontSize: 15, fontWeight: 900, color: '#fff', lineHeight: 1.15 }}>DHA MEDICAL</div>
              <div style={{ fontSize: 15, fontWeight: 900, color: '#fff', lineHeight: 1.15 }}>CENTRE</div>
            </div>
          )}
        </div>
        {(mobile || !collapsed) && (
          <>
            <div style={{ height: 1, background: 'rgba(255,255,255,0.15)', marginBottom: 10 }} />
            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 10, color: '#94a3b8', letterSpacing: 0.3 }}>In Collaboration with</div>
              <div style={{ fontSize: 16, fontWeight: 900, color: RED, letterSpacing: 1, lineHeight: 1.1 }}>CARELINE</div>
            </div>
          </>
        )}
      </div>

      <nav style={{ flex: 1, overflowY: 'auto', padding: '8px 0', scrollbarWidth: 'none' }}>
        {navItems.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              gap: (!mobile && collapsed) ? 0 : 10,
              padding: (!mobile && collapsed) ? '13px 0' : '11px 14px',
              justifyContent: (!mobile && collapsed) ? 'center' : 'flex-start',
              textDecoration: 'none',
              color: isActive ? '#fff' : '#93c5fd',
              background: isActive ? 'rgba(255,255,255,0.10)' : 'transparent',
              borderLeft: isActive ? '3px solid ' + item.color : '3px solid transparent',
              transition: 'all 0.15s',
              fontSize: 13,
              fontWeight: isActive ? 700 : 400,
            })}
          >
            <span style={{ fontSize: 17, flexShrink: 0 }}>{item.icon}</span>
            {(mobile || !collapsed) && (
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.label}</span>
            )}
          </NavLink>
        ))}
      </nav>

      {(mobile || !collapsed) && (
        <div style={{ padding: '10px 14px', borderTop: '1px solid rgba(255,255,255,0.07)' }}>
          <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 2 }}>Logged in as</div>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#e2e8f0', marginBottom: 8, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {userName}
          </div>
          <NavLink
            to="/change-password"
            style={{ display: 'block', textAlign: 'center', padding: '7px 0', borderRadius: 6,
              background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.12)',
              color: '#93c5fd', fontSize: 12, fontWeight: 600, marginBottom: 6, textDecoration: 'none' }}
          >
            🔑 Change Password
          </NavLink>
          <button
            onClick={onLogout}
            style={{ width: '100%', padding: '7px 0', borderRadius: 6,
              background: 'rgba(196,30,58,0.18)', border: '1px solid rgba(196,30,58,0.4)',
              color: '#fca5a5', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
          >
            Logout
          </button>
        </div>
      )}

      {!mobile && (
        <button
          onClick={() => setCollapsed(c => !c)}
          style={{ background: 'rgba(255,255,255,0.07)', border: 'none', color: '#94a3b8',
            padding: '12px', cursor: 'pointer', fontSize: 16, textAlign: 'center',
            borderTop: '1px solid rgba(255,255,255,0.07)' }}
        >
          {collapsed ? '▶' : '◀'}
        </button>
      )}
    </div>
  );

  if (isMobile) {
    return (
      <div style={{ minHeight: '100vh', background: '#f1f5f9' }}>
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
          background: NAVY, display: 'flex', alignItems: 'center', padding: '0 16px', height: 52,
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>
          <button
            onClick={() => setMobileOpen(o => !o)}
            style={{ background: 'none', border: 'none', color: '#fff', fontSize: 22, cursor: 'pointer', padding: '4px 8px', marginRight: 12 }}>
            ☰
          </button>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 900, color: '#fff', lineHeight: 1.1 }}>DHA MEDICAL CENTRE</div>
            <div style={{ fontSize: 10, color: RED, fontWeight: 700 }}>CARELINE</div>
          </div>
          <div style={{ fontSize: 11, color: '#94a3b8' }}>{userName}</div>
        </div>

        {mobileOpen && (
          <>
            <div
              onClick={() => setMobileOpen(false)}
              style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 300 }}
            />
            <div style={{ position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 400,
              boxShadow: '4px 0 20px rgba(0,0,0,0.4)', display: 'flex', flexDirection: 'column' }}>
              {sidebarContent(true)}
            </div>
          </>
        )}

        <div style={{ paddingTop: 52 }}>
          {children}
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f1f5f9' }}>
      <div style={{
        width: w, minWidth: w, maxWidth: w,
        position: 'fixed', top: 0, left: 0, bottom: 0,
        zIndex: 100, transition: 'width 0.22s ease',
        boxShadow: '3px 0 16px rgba(0,0,0,0.25)',
        display: 'flex', flexDirection: 'column',
      }}>
        {sidebarContent(false)}
      </div>
      <div style={{ marginLeft: w, flex: 1, transition: 'margin-left 0.22s ease', minHeight: '100vh' }}>
        {children}
      </div>
    </div>
  );
}
